import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import useDocumentTitle from '../hooks/useDocumentTitle';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useDocumentTitle('Cognidaily | Reset Password');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;

    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/forgot-password', { email });
      const payload = response.data;

      if (payload.success) {
        setSuccess(
          'If an account with that email exists, a password reset link has been sent.'
        );
      } else {
        setError(
          payload.error ||
            payload.message ||
            'Unable to process password reset request. Please try again.'
        );
      }
    } catch (err: any) {
      const message: string | undefined =
        err.response?.data?.error || err.response?.data?.message;
      setError(
        message ||
          'Unable to process password reset request. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section section--auth">
        <h1>Forgot your password?</h1>
        <p>Enter your email and we&apos;ll send you a reset link.</p>
        {error && <p role="alert" className="text-error">{error}</p>}
        {success && <p>{success}</p>}
        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Sending...' : 'Send reset link'}</button>
        </form>
        <p><Link to="/login" className="link">Back to sign in</Link></p>
    </section>
  );
};

export default ForgotPassword;




































